var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "current",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7876.97,-2706.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "team",
    transform: "matrix(0.5,0,0,0.5,7876.97,2706.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5314,0,0,1.5314,-3923.12,-454.826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2633.58,358.257C2633.58,360.598 2632.41,362.784 2630.46,364.083L2607.46,379.409C2605.11,380.975 2602.05,380.975 2599.7,379.409L2576.7,364.083C2574.75,362.784 2573.58,360.598 2573.58,358.257L2573.58,319.005C2573.58,315.139 2576.71,312.005 2580.58,312.005L2626.58,312.005C2630.44,312.005 2633.58,315.139 2633.58,319.005L2633.58,358.257ZM2601.27,324.459L2597.13,333.124L2587.61,334.386C2586.63,334.515 2585.82,335.193 2585.51,336.13C2585.21,337.067 2585.47,338.095 2586.18,338.773L2593.14,345.39L2591.4,354.835C2591.22,355.804 2591.62,356.789 2592.41,357.368C2593.21,357.946 2594.27,358.016 2595.13,357.547L2603.58,352.972L2612.02,357.547C2612.89,358.016 2613.95,357.946 2614.74,357.368C2615.54,356.789 2615.93,355.804 2615.76,354.835L2614.01,345.39L2620.97,338.773C2621.69,338.095 2621.95,337.067 2621.64,336.13C2621.34,335.193 2620.52,334.515 2619.55,334.386L2610.03,333.124L2605.89,324.459C2605.46,323.57 2604.56,323.005 2603.58,323.005C2602.59,323.005 2601.7,323.57 2601.27,324.459ZM2643.58,302.002C2643.58,304.763 2641.34,307.005 2638.58,307.005L2568.58,307.005C2565.82,307.005 2563.58,304.763 2563.58,302.002C2563.58,299.241 2565.82,297 2568.58,297L2638.58,297C2641.34,297 2643.58,299.241 2643.58,302.002Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.11e0667cf43fdb0c9f58590131203210.svg";
export { ForwardRef as ReactComponent };